module.exports = __webpack_public_path__ + "static/media/iot-development02.2c993cc4.jpg";